import { useSite } from '@on3/ui-lib/index';
import { Link } from '@public/components/Link';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

import styles from './TransferPortalNav.module.scss';

interface ITransferPortalNavProps {
  type?: string;
  year?: string;
  className?: string;
}
export const TransferPortalNav = ({
  type,
  year,
  className,
}: ITransferPortalNavProps) => {
  const { currentSite } = useSite();
  const primaryColor =
    currentSite?.linkColor || currentSite?.primaryColor || '#fe3b1f';
  const unactiveColor = '#6f747b';
  const activeStyle = {
    color: primaryColor,
    borderColor: primaryColor,
  };
  const unactiveStyle = {
    color: unactiveColor,
    border: 'none',
  };
  const router = useRouter();

  const { query, pathname, asPath } = router;
  const { sport, transferType } = query;

  const transferPortalView = type || transferType?.toString();

  const isWire = transferPortalView === 'wire';
  const isTop = transferPortalView === 'best-available';
  const isTeamRank = pathname.includes('team-rankings');
  const getHref = useCallback(
    (title: string) => {
      const urlPath = asPath.replace(
        /\b(top|wire|industry|team-rankings)\b/,
        title,
      );

      if (query) {
        return urlPath.split('?')[0];
      }

      return urlPath;
    },
    [asPath, query],
  );

  return (
    <div className={clsx(styles.block, className)}>
      <Link
        className={clsx(styles.filter, {
          [styles.active]: isTop,
        })}
        href={getHref('industry')}
        style={isTop ? activeStyle : unactiveStyle}
      >
        Top
      </Link>
      <Link
        className={clsx(styles.filter, {
          [styles.active]: isWire,
        })}
        href={getHref('wire')}
        style={isWire ? activeStyle : unactiveStyle}
      >
        Transfer Portal
      </Link>
      <Link
        className={clsx(styles.filter, {
          [styles.active]: isTeamRank,
        })}
        href={`/transfer-portal/team-rankings/${sport}/${year}/`}
      >
        Rankings
      </Link>
    </div>
  );
};
